import { ActionType } from 'typesafe-actions'
import { Moment } from 'moment-timezone'
import * as actions from './actions'
import { Event } from 'features/types/event'

export type DashboardAction = ActionType<typeof actions>

export interface StoreState {
  data: DashboardData
  originalData: DashboardData
  event: Event
  query: DashboardQuery
  sorting: any
  filter: DashboardFilter
}

export type Todo = {
  CheckListID: number
  CheckListName: string
  CheckListType: string
  ActivityID: string
  ActivityName: string
  Progress: number
  LastCurProgress: number
  LastReqProgress: number
  State: 'MC' | 'CM' | 'PJPO'
  TaskStatus: 'INIT' | 'INPRO' | 'APPV' | 'REJT'
  BaselineStartDate: string
  BaselineFinishDate: string
  StartDate: string
  FinishDate: string
  ActualStartDate: string
  ActualFinishDate: string
}

export type InProgress = {
  ProjectCode: string
  RequestID: number
  CheckNumber: number
  AppointmentDate: string
  CheckStatus: 'Pass' | 'NotPass' | 'NotPassByReqDefect'
  InspectionScore: number
  BasePoint: number
  State: 'CM' | 'QC'
  Status: 'INIT' | 'INPRO' | 'APPV' | 'REJT'
  ChecklistTypeName: string
  ChecklistTypeID: number
}

export type FixFromQC = {
  ProjectCode: string
  RequestID: number
  CheckNumber: number
  AppointmentDate: string
  CheckStatus: 'Pass' | 'NotPass' | 'NotPassByReqDefect'
  ReturnInDate: number
  ReturnInHour: number
  CheckedDate: string
  InspectionScore: number
  BasePoint: number
  State: 'CM' | 'QC'
  Status: 'INIT' | 'INPRO' | 'APPV' | 'REJT'
  ChecklistTypeName: string
  ChecklistTypeID: number
}

export interface GetDashboardReq {
  ProjectCode: string
  UserEmail: string
}

export interface GetActivityApiResponse extends GetApiResponse<DashboardData> {}

export interface GetApiResponse<T> {
  ResponseData: T
  ResponseCode: string
  ResponseMsg: 'Success' | 'Error'
  RequestTime: string
  Responsetime: string
}

export type DashboardData = {
  TotalInProgress: number
  InProgress: InProgress[]
  TotalFixFromQC: number
  FixFromQC: FixFromQC[]
}

export type DashboardEvent = {
  isFetching: boolean
  error: string
}

export type DashboardFilter = {}

export type DashboardQuery = {
  date: {
    start: undefined | Moment
    end: undefined | Moment
  }
}

export enum TypeOfTask {
  InProgress = 'inProgress',
  FixFromQC = 'fixFromQC',
}
